// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"OrdinancesTreeViewData_contextMenu__1-YvR","contextMenuElement":"OrdinancesTreeViewData_contextMenuElement__12JAb"};